<template>
	<div class="platef">
		<!-- 示例：触发按钮（你可以从外部控制显示） -->
		<!-- <van-button type="primary" @click="openKeyboard">选择车牌</van-button> -->

		<!-- 车牌弹窗 -->
		<van-popup v-model:show="popupVisible" position="bottom" :close-on-click-overlay="true" @close="onPopupClose">
			<div class="popup">
				<div class="keyboard">
					<div v-for="(it, key) in plateData" :key="key" class="item" @click="addToPlate(it)">
						{{ it }}
					</div>
					<div v-if="plate.length > 0" class="item delete" @click="deleteFromPlate">
						删除
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>
  
<script>
// 如果是 Vue 3 + Options API（兼容你原写法）
export default {
	name: 'CsflPlate',
	props: {
		value: {
			type: String,
			default: ''
		},
		limit: {
			type: Number,
			default: 8
		}
	},
	data() {
		return {
			plate: this.value || '',
			popupVisible: false,
			province: ["陕", "京", "津", "沪", "渝", "冀", "晋", "辽", "吉", "黑", "闽", "苏", "浙", "皖", "鄂", "湘", "粤", "琼", "赣",
				"鲁", "豫", "川", "贵", "云", "甘", "青", "藏", "桂", "蒙", "宁", "新", "港", "澳"],
			letter: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
			number: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "警", "学"]
		}
	},
	computed: {
		plateData() {
			if (this.plate.length === 0) {
				return this.province;
			} else if (this.plate.length === 1) {
				return this.letter;
			} else {
				return [...this.letter, ...this.number];
			}
		}
	},
	watch: {
		value(val) {
			this.plate = val;
		},
		plate(val) {
			this.$emit('input', val);
		},
		limit(val) {
			// if (this.plate.length > val) {
			this.plate = this.plate.substring(0, val);
			// }
		}
	},
	methods: {
		// 对外暴露打开方法
		openKeyboard() {
			this.plate = '';
			this.popupVisible = true;
		},

		addToPlate(value) {
			console.log(this.plate.length)
			if (this.plate.length + 1 > this.limit) {
				this.popupVisible = false;
			} else {
				this.plate += value;
			}
		},

		deleteFromPlate() {
			this.plate = this.plate.slice(0, -1);
		},

		onPopupClose() {
			this.$emit('input', this.plate); // 确保关闭时同步值
			// 注意：Vant 的 close 事件在点击遮罩/返回键时也会触发
		}
	}
}
</script>
  
<style scoped lang="scss">
.popup {
	background-color: #dcdcdc;
	width: 100%;
	padding: 10px 0;

	.keyboard {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		padding: 10px 0;

		.item {
			width: 45px;
			height: 45px;
			background-color: #fff;
			border-radius: 8px;
			margin: 5px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 16px;
			color: #333;
			cursor: pointer;
		}

		.delete {
			width: 60px;
		}
	}
}
</style>